<template>
  <div class="banner-general">
    <div class="banner-general__text-container">
      <p class="Body3">On-Demand Consultation Status</p>
      <p v-html="statusText"
         class="Title1"></p>
    </div>

    <smd-btn class="btn004 btn004--unselected banner-general__btn"
             @click.stop.prevent="$emit('hide-banner')" >
      Hide
    </smd-btn>
  </div>
</template>

<script>
  export default {
    name: 'banner-general',
    props: {
      statusText: {type: String},
    },
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .banner-general {
    @extend %layout--flex-row-center-x;
    justify-content: space-between;
    background-image: linear-gradient(
      120deg,
      transparent 0%,
      transparent 33%,
      transparent 67%,
      color(gray-400) 160%
    );
  }
</style>
